export function fmtSize(bytes: number): string {
  let b = bytes
  if (b < 1000) return b + ' B'
  const u = ['KB', 'MB', 'GB', 'TB']
  let i = -1
  do {
    b /= 1000
    i++
  } while (b >= 1000 && i < u.length - 1)
  return b.toFixed(b < 10 ? 2 : 1) + ' ' + u[i]
}
